<template>
  <a-layout>
    <Breadcrumb>
      <BreadcrumbItem> 查看 </BreadcrumbItem>
    </Breadcrumb>
    <div class="page-title-container">
      <span class="page-title">项目基本信息</span>
    </div>
    <div class="content-container">
      <div class="container">
        <div class="steps-content">

          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">电站性质</span>
            </div>
            <div class="field-content">
              <p>{{ sectionTwo.usageAgreement }}</p>
              <p><span class="item-label">租赁年份：</span>{{ sectionTwo.leaseStartYear }} 年</p>
              <p><span class="item-label">租金：</span>{{ sectionTwo.leasePrice }} 元 / m² · 年</p>
              <p><span class="item-label">EMC电价：</span>{{ sectionTwo.settlePrice }} 元 / kwh</p>
              <p><span class="item-label">备注说明：</span>{{ sectionTwo.usageAgreementRemark }}</p>
              <p v-if="energyContract.docList.length > 0">--能源租赁合同--</p>
              <p v-for="doc in energyContract.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
              <p v-if="roofLeaseContract.docList.length > 0">--屋顶租赁合同--</p>
              <p v-for="doc in roofLeaseContract.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">房屋无大量灰尘，无易燃易爆物品、气体，防爆等级高于乙类厂房不可用</span>
            </div>
            <div class="field-content">
              <p>{{sectionTwo.explosiveRisk}}</p>
              <p v-if="sectionTwo.explosiveRisk==='不符合'">备注说明：{{ sectionTwo.explosiveRiskRemark }}</p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">生产过程中不产生腐蚀气体</span>
            </div>
            <div class="field-content">
              <p>{{ sectionTwo.produceCorrosive }}</p>
              <p v-if="sectionTwo.produceCorrosive==='不符合'">备注说明：{{ sectionTwo.produceCorrosiveRemark }}</p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">钢结构房屋需为10年以内建筑，房屋无漏水，彩钢瓦无明显锈蚀；砖混结构厂房需为30年以内建筑</span>
            </div>
            <div class="field-content">
              <p>{{ sectionTwo.leakingRisk }}</p>
              <p v-if="sectionTwo.leakingRisk==='不符合'">备注说明：{{ sectionTwo.leakingRiskRemark }}</p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">砖墙结构房屋无明显墙体开裂、墙体倾斜现象</span>
            </div>
            <div class="field-content">
              <p>{{ sectionTwo.collapseRisk }}</p>
              <p v-if="sectionTwo.collapseRisk==='不符合'">备注说明：{{ sectionTwo.collapseRiskRemark }}</p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">平屋顶需为混凝土浇筑屋面或厚度不小于80mm的混凝土预制板或厚度不低于80mm的双T板</span>
            </div>
            <div class="field-content">
              <p>{{ sectionTwo.flatRoof }}</p>
              <p v-if="sectionTwo.flatRoof==='不符合'">备注说明：{{ sectionTwo.flatRoofRemark }}</p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">斜屋顶需为实铺平瓦屋面、钢筋混凝土挂瓦板平瓦屋面，且屋面结构简单无特殊造型</span>
            </div>
            <div class="field-content">
              <p>{{ sectionTwo.slopeRoof }}</p>
              <p v-if="sectionTwo.slopeRoof==='不符合'">备注说明：{{ sectionTwo.slopeRoofRemark }}</p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">屋顶应当无漏雨漏水现象、斜屋顶屋面瓦面破损率不大于15%，且光伏安装完成后屋面瓦面破损率为0</span>
            </div>
            <div class="field-content">
              <p>{{ sectionTwo.breakage }}</p>
              <p v-if="sectionTwo.breakage==='不符合'">备注说明：{{ sectionTwo.breakageRemark }}</p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">屋面周围无外部遮挡</span>
            </div>
            <div class="field-content">
              <p>{{ sectionTwo.blockage }}</p>
              <p v-if="sectionTwo.blockage==='不符合'">{{ sectionTwo.blockageRemark }}</p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">若房屋或厂房在设计建设时已考虑加装光伏系统情况（以设计图纸为依据，由光伏设计人员核算并出具满足荷载的核算报告）外，其它房屋或厂房必须出具荷载报告</span>
            </div>
            <div class="field-content">
              <p>{{ sectionTwo.solarConsidered }}</p>
              <p v-if="sectionTwo.solarConsidered==='不符合'">备注说明：{{ sectionTwo.solarConsideredRemark }}</p>
              <p v-if="solarBlueprint.docList.length>0">--厂区建筑结构图--</p>
              <p v-for="doc in solarBlueprint.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">屋顶坡度大于10度时，北坡不可用</span>
            </div>
            <div class="field-content">
              <p>{{ sectionTwo.slopeDegree }}</p>
              <p v-if="sectionTwo.slopeDegree==='不符合'">备注说明：{{ sectionTwo.slopeDegreeRemark }}</p>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label optional-field field-label__bold">厂房屋顶鸟瞰图、厂房内部天花板图、厂房内照片等房屋现状图</span>
            </div>
            <div class="field-content">
              <p v-for="doc in sitePhoto.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
              <span v-if="sitePhoto.docList.length ===0">暂无</span>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label optional-field field-label__bold">厂区电气一次系统图（CAD版）</span>
            </div>
            <div class="field-content">
              <p v-for="doc in electricalDiagram.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
              <span v-if="electricalDiagram.docList.length ===0">暂无</span>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label required-field field-label__bold">厂区变压器容量（多台变压器应分别描述）</span>
            </div>
            <div class="field-content">
              <p>{{sectionTwo.transformers}}</p>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label required-field-container">
              <span class="field-label optional-field field-label__bold">设计方案组件排布图</span>
            </div>
            <div class="field-content">
              <p v-for="doc in componentDiagram.docList" :key="doc.uid">
                <a @click="preview(doc)"><a-icon type="paper-clip" /> {{ doc.name }}</a>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <DocPreview ref="docPreview" />
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import {baseURL} from "@/services/HttpService";
import {loadSectionTwo, saveAdditionalDocs} from "@/services/SpecService";
import DocPreview from "@/views/DocPreview.vue";
import {changeToAbsImgPath} from "@/utils/absUrl";

export default {
  components: {BreadcrumbItem, Breadcrumb, DocPreview},
  props: {
    projectId: String,
    mode: String
  },
  data() {
    return {
      viewUrl: baseURL + "/attachment?fileName=",
      uploadUrl: baseURL + "/upload/spec",
      sectionTwo: {
        companyId: "",
        explosiveRisk: "",
        explosiveRiskRemark: "",
        produceCorrosive: "",
        produceCorrosiveRemark: "",
        leakingRisk: "",
        collapseRisk: "",
        flatRoof: "",
        slopeRoof: "",
        breakage: "",
        blockage: "",
        blockageRemark: "",
        solarConsidered: "",
        slopeDegree: "",
        rationaleState: "",
        usageAgreement: "",
        leaseStartYear: "",
        leasePrice: "",
        settlePrice: "",
        transformers: "",
        isEditable: false
      },

      energyContract: {
        loading: false,
        docList: [],
        title: "能源租赁合同"
      },
      roofLeaseContract: {
        loading: false,
        docList: [],
        title: "屋顶租赁合同"
      },

      solarBlueprint: {
        loading: false,
        docList: [],
        title: "设计图纸（组件排布图）"
      },
      sitePhoto:{
        loading: false,
        docList: [],
        title: "厂房屋顶鸟瞰图、厂房内部天花板图、厂房内照片等房屋现状图"
      },
      electricalDiagram: {
        loading: false,
        docList: [],
        title: "厂区电气一次系统图（CAD版）"
      },
      componentDiagram: {
        loading: false,
        docList: [],
        title: "设计方案组件排布图"
      },

    };
  },
  mounted() {
    this.startLoadSectionTwo();
  },
  methods: {
    getCompanyId() {
      return this.sectionTwo.companyId;
    },
    startLoadSectionTwo(){
      if(this.projectId && this.projectId!=="" && this.projectId !== "0") {
        loadSectionTwo(this.projectId).then(resp => {
          if (resp.data.code === "SUCCESS") {
            let data = resp.data.data;
            this.sectionTwo = data;

            this.buildDocList(data.solarBlueprintDocList, 'solarBlueprint');
            console.log();
            this.buildDocList(data.sitePhotoDocList, 'sitePhoto');
            this.buildDocList(data.energyContractDocList, 'energyContract');
            this.buildDocList(data.roofLeaseContractDocList, 'roofLeaseContract');
            this.buildDocList(data.electricalDiagramDocList, 'electricalDiagram');
            this.buildDocList(data.componentDiagramDocList, 'componentDiagram');
          }
        });
      }
    },
    buildDocList(docList, propName) {
      if(docList && docList.length > 0) {
        for (let i = 0; i < docList.length; i++) {
          let doc = docList[i];
          this[propName].docList.push({
            uid: doc.uid,
            name: doc.name,
            status: 'done',
            url: this.viewUrl + doc.url
          });
        }
      }
    },
    onRegistrationDocUpload(info) {
      let fileList = changeToAbsImgPath(info);
      this.registration.docList = fileList;
      if(info.file.status==='done' || info.file.status==='removed'){
        this.saveDoc(fileList, '备案证');
      }
    },
    saveDoc(fileList, typeName){
      let params = {
        projectId: this.projectId,
        type: typeName,
        fileList: []
      }
      this.prepareDocList(this.registration.docList, params, "fileList");
      saveAdditionalDocs(params).then(resp => {
        if(resp.data.code !== "SUCCESS") {
          this.$message.error("保存文件失败");
        }
      });
    },
    prepareDocList(docList, params, propName){
      if(docList.length > 0) {
        for (let i = 0;i< docList.length; i++) {
          let oneDoc = docList[i];
          params[propName].push({
            uid: oneDoc.uid,
            name: oneDoc.name,
            url: oneDoc.url.replace(this.viewUrl, '')
          });
        }
      }
    },
    preview(doc) {
      this.$refs.docPreview.previewFile(doc);
    },

  }
}
</script>
<style scoped>
.item-label {
  display: inline-block;
  width: 6em;
  font-weight: bold;
}
</style>